//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '../../assets/style/weui.css';
import '../../api/openjsbridge.icity.js'
export default {

  components: {

  },
  data() {
    return {
      transList:[]
    };
  },
  created() {
    this.getTransList()
  },

  mounted() {



  },
  methods: {


    getTransList: async function(){
      this.transList=[]
      const _this=this;
      let params = {
        commercialNumber:this.$cookies.get('commercialNo'),
        token:this.$cookies.get('wxToken'),

      };
      console.log(params);
      const response = await this.$api.postjson("/wechat/order", params);
      console.log('缴费记录查询',response)
      if(response.data.code=='0000') {
        _this.transList=response.data.data
      }

      else{
        _this.$vux.toast.show({
          text: response.data.msg,
          type: "warn",
          time:'3000'
        })
      }

    },








  }
};



// WEBPACK FOOTER //
// ./src/views/wx/transList.vue